module.exports = __webpack_public_path__ + "static/media/result_fhl_ja_old.f79258ec.jpg";